// extracted by mini-css-extract-plugin
export default {"lagNy":"styles_lagNy__tdcr1","overskrift":"styles_overskrift__z8HVw","container":"styles_container__qrleI"};